import React from "react";
import { ColumnTypes, GroupedColumnTypes, ColumnTypeLabels } from "components/collections/util/datatypes";
import DefaultValue from "components/collections/forms/ColumnFormView.sub.default.view";
import ColorPicker from "components/util/helpers/ColorPicker";
import l from "components/util/l";
import SelectDescriptive from "components/util/helpers/SelectDescriptiveField";

const ColumnField = ({
  field,
  idx,
  flow,
  values,
  isGenerated,
  collections = [],
  showMoveButtons = false,
  showDeleteButton = false,
  setFieldValue,
}) => {

  return <>
    <tr
      key={`field-table-${idx}`}
      className={isGenerated ? " animate__animated animate__fadeIn animate__faster" : ""}
      style={{
        background: idx % 2 ? "#f9f9f9" : "#fff",
      }}
    >

      <td>
        <input
          type="text"
          name={`label_${idx}`}
          id={`label_${idx}`}
          className="form-control font-weight-bold"
          placeholder={l("Nombre del campo%CA037")}
          value={field.final.label}
          onClick={(e) => setFieldValue("selected_field", idx)}
          onChange={(e) => {

            setFieldValue(
              "structure",
              values?.structure?.map((f, i) => {
                if (i == idx) return {
                  ...f,
                  final: {
                    ...f.final,
                    label: e.target.value,
                  },
                  action: f.initial ? "update" : "create"
                };
                return f;
              })
            );

          }}
        />
      </td>

      <td>
        <select
          name={`structure_${idx}`}
          id={`structure_${idx}`}
          className="form-control"
          value={field.final.type}
          onChange={(e) => {
            const enumValues = [...field.final?.structure?.values ?? [{ value: "Valor 1", color: "#FFFFFF" }]];
            setFieldValue("selected_field", idx)
            setFieldValue(
              "structure",
              values?.structure?.map((f, i) => {
                if (i == idx) return {
                  ...f,
                  final: {
                    ...f.final,
                    structure: { ...(e.target.value == ColumnTypes.ENUM ? { values: enumValues } : null) },
                    type: e.target.value,
                  },
                  action: "update"
                };
                return f;
              })
            );
          }}
        >
          {
            GroupedColumnTypes.map((group, i) => (
              <optgroup key={`group-${i}`} label={group.label}>
                {
                  group.types.map((type, j) => (
                    <option
                      key={`type-${i}-${j}`}
                      value={type}
                      selected={field.final.type == type}
                    >
                      {l(ColumnTypeLabels[type])}
                    </option>
                  ))
                }
              </optgroup>
            ))
          }
        </select>
      </td>

      {
        showMoveButtons &&
        <td>
          <div class="btn-group" role="group">
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              disabled={idx == 0}
              onClick={() => {
                let auxStructure = values?.structure ?? [];
                let newStructure = [...auxStructure];
                let tmp = newStructure[idx - 1];
                newStructure[idx - 1] = newStructure[parseInt(idx)];
                newStructure[parseInt(idx)] = tmp;
                setFieldValue("structure", newStructure);
                setFieldValue("selected_field", null);
              }}
            >
              <i class="fas fa-arrow-up"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              disabled={idx == values?.structure?.filter(f => f.action != "delete" && !f.internal).length - 1}
              onClick={() => {
                let auxStructure = values?.structure ?? [];
                let newStructure = [...auxStructure];
                let tmp = newStructure[idx + 1];
                newStructure[idx + 1] = newStructure[parseInt(idx)];
                newStructure[parseInt(idx)] = tmp;
                setFieldValue("structure", newStructure);
                setFieldValue("selected_field", null);
              }}
            >
              <i class="fas fa-arrow-down"></i>
            </button>
          </div>
        </td>
      }

      {
        showDeleteButton &&
        <td>
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            onClick={() => {
              setFieldValue("structure", values?.structure?.map((f, i) => {
                if (i == idx) return {
                  ...f, final: {
                    ...(f.initial || f.final),
                  }, action: "delete"
                };
                return f;
              }));
              setFieldValue("selected_field", null);
            }}
          >
            <i class="fas fa-trash"></i>
          </button>
        </td>
      }

    </tr>

    {
      (values.selected_field == idx) &&
      <tr
        style={{
          background: idx % 2 ? "#f9f9f9" : "#fff",
        }}
      >
        <td colSpan="4">
          <div className="d-flex flex-column justify-content-start px-2">

            {/* Enum options */}
            <div
              className="w-100 mb-2"
              style={{
                display: field.final?.type == ColumnTypes.ENUM ? "block" : "none"
              }}
            >
              <h6 style={{ color: "#777" }}>{l("Valores%CA039")}</h6>
              {
                field.final?.structure?.values?.map((value, i) =>
                  <div
                    key={`enum-value-${value?.value}-${i}`}
                    className="d-flex justify-content-between w-100 my-2"
                  >

                    <input
                      type="text"
                      className="form-control form-control-sm"
                      defaultValue={value.value}
                      onBlur={(e) => {
                        const enumValues = [...field.final?.structure?.values ?? []];
                        enumValues[i] = { value: e.target.value, color: enumValues[i].color ?? "#FFFFFF" };
                        setFieldValue("structure", values?.structure?.map((f, j) => {
                          if (j == idx) return { ...f, final: { ...f.final, structure: { values: enumValues } } };
                          return f;
                        }));
                      }}
                    />

                    <div className="h-100">
                      <ColorPicker
                        id={`enum-color-${i}`}
                        values={values}
                        defaultColor={value.color ?? "transparent"}
                        setFieldValue={setFieldValue}
                        value={value.color ?? "transparent"}
                        side="left"
                        onChange={(color) => {
                          const enumValues = [...field.final?.structure?.values ?? []];
                          enumValues[i] = { value: enumValues[i].value, color: color };
                          setFieldValue("structure", values?.structure?.map((f, j) => {
                            if (j == idx) return { ...f, final: { ...f.final, structure: { values: enumValues } } };
                            return f;
                          }));
                        }}
                      />
                    </div>

                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary"
                      disabled={i == 0}
                      onClick={() => {
                        let structure = [...field.final?.structure?.values ?? []];
                        let tmp = structure[i - 1];
                        structure[i - 1] = structure[parseInt(i)];
                        structure[parseInt(i)] = tmp;
                        setFieldValue("structure", values?.structure?.map((f, j) => {
                          if (j == idx) return { ...f, final: { ...f.final, structure: { values: structure } } };
                          return f;
                        }));
                      }}
                    >
                      <i class="fas fa-arrow-up"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary"
                      disabled={i == field.final?.structure?.values.length - 1}
                      onClick={() => {
                        let structure = [...field.final?.structure?.values ?? []];
                        let tmp = structure[i + 1];
                        structure[i + 1] = structure[parseInt(i)];
                        structure[parseInt(i)] = tmp;
                        setFieldValue("structure", values?.structure?.map((f, j) => {
                          if (j == idx) return { ...f, final: { ...f.final, structure: { values: structure } } };
                          return f;
                        }));
                      }}
                    >
                      <i class="fas fa-arrow-down"></i>
                    </button>

                    <button
                      type="button"
                      className="btn btn-sm btn-danger ml-1"
                      onClick={() => {
                        const enumValues = [...field.final?.structure?.values ?? []];
                        enumValues.splice(i, 1);
                        setFieldValue("structure", values?.structure?.map((f, j) => {
                          if (j == idx) return {
                            ...f, final: {
                              ...f.final,
                              structure: enumValues.length > 0 ? { values: enumValues } : null
                            }
                          };
                          return f;
                        }));
                      }}
                    >
                      <i className="fas fa-trash"></i>
                    </button>

                  </div>
                )
              }

              <button
                type="button"
                className="btn btn-sm btn-outline-primary mt-2 w-100"
                onClick={() => {
                  const enumValues = [...(field.final?.structure?.values ?? [])];
                  enumValues.push({ value: "", color: "#FFFFFF" });
                  setFieldValue("structure", values?.structure?.map((f, j) => {
                    if (j == idx) return { ...f, final: { ...f.final, structure: { values: enumValues } } };
                    return f;
                  }));
                }}
              >
                {l("Agregar%GA081")}
              </button>

            </div>

            {/* Collection options */}
            <div
              className="w-100 mb-2"
              style={{
                display: field.final?.type == ColumnTypes.COLLECTION ? "block" : "none"
              }}
            >
              <h6 style={{ color: "#777" }}>{l("Tabla%GA054")}</h6>
              <SelectDescriptive
                name={`field-${field.final?.name}-${idx}-collection`}
                value={field.final?.structure?.collection_id}
                options={
                  collections.map(c => ({
                    value: c.id,
                    label: (flow.id != c.flow.id ? c.flow.name + " - " : "") + (c?.uiSettings?.label ?? c.name),
                    hidden: flow.id != c.flow.id
                  })).sort((a, b) => {
                    if (a.hidden && !b.hidden) return 1;
                    if (!a.hidden && b.hidden) return -1;
                    return 0;
                  })
                }
                onChange={(e) => {

                  if (e.target.value == -1) return setFieldValue("structure", values?.structure?.map((f, j) => {
                    if (j == idx) return { ...f, final: { ...f.final, structure: null } };
                    return f;
                  }));

                  const collection = collections.find(c => c.id == e.target.value);
                  if (!collection) return;

                  setFieldValue("structure", values?.structure?.map((f, j) => {
                    if (j == idx) return {
                      ...f, final: {
                        ...f.final,
                        structure: { collection_id: collection.id, type: "@" + collection.name }
                      }
                    };
                    return f;
                  }));

                }}
              />
            </div>

            <div>
              <button
                type="button"
                className="btn btn-sm btn-link text-start m-0 p-0"
                data-toggle="collapse"
                data-target={`#column-field-options-${field?.final?.name}-${idx}`}
                aria-expanded="false"
                aria-controls={`column-field-options-${field?.final?.name}-${idx}`}
              >
                {l("Opciones avanzadas%SA220")} <i className="fas fa-chevron-down"></i>
              </button>
            </div>

            {/* Advance options */}
            <div
              id={`column-field-options-${field?.final?.name}-${idx}`}
              className="collapse pt-3 pb-2"
            >

              {/* All fields options */}


              <div className="w-100 mb-2">
                <h6 style={{ color: "#777" }}>{l("Descripción%GA077")}</h6>
                <textarea
                  className="form-control form-control-sm"
                  rows="2"
                  value={field.final.description}
                  onChange={(e) => {
                    setFieldValue("structure", values?.structure?.map((f, j) => {
                      if (j == idx) return {
                        ...f,
                        final: {
                          ...f.final,
                          description: e.target.value
                        }
                      };
                      return f;
                    }));
                  }}
                />
              </div>

              <div className="w-100 mb-2">
                <div className="d-flex justify-content-start align-items-center mt-2 mb-2">
                  <h6 className="m-0 p-0 text-nowrap mr-2" style={{ color: "#777" }}>{l("Valor por defecto%CA153")}</h6>
                  <DefaultValue
                    idx={idx}
                    field={field}
                    values={values}
                    setFieldValue={setFieldValue}
                  />
                </div>
                <div className="d-flex justify-content-start align-items-center">
                  <input
                    type="checkbox"
                    className="from-control mr-2"
                    checked={field?.final?.name == values?.primary_key || field?.initial?.name == values?.primary_key}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setFieldValue("modified_pk", true);
                        setFieldValue("primary_key", field.final.name);
                      }
                    }}
                  />
                  <h6 className="m-0 p-0" style={{ color: "#777" }}>{l("Asignar como llave primaria%CA038")}</h6>
                </div>
                <div className="d-flex justify-content-start align-items-center mt-2">
                  <input
                    type="checkbox"
                    className="from-control mr-2"
                    checked={field?.final?.read_only}
                    onChange={(e) => {
                      setFieldValue("structure", values?.structure?.map((f, j) => {
                        if (j == idx) return {
                          ...f,
                          final: {
                            ...f.final,
                            read_only: e.target.checked
                          }
                        };
                        return f;
                      }));
                    }}
                  />
                  <h6 className="m-0 p-0" style={{ color: "#777" }}>{l("Solo lectura%CA151")}</h6>
                </div>
              </div>

              {/* Float options */}
              <div
                className="w-100"
                style={{
                  display: field.final?.type == ColumnTypes.FLOAT ? "block" : "none"
                }}
              >
                <div className="d-flex justify-content-start align-items-center">
                    <input
                    type="checkbox"
                    className="from-control mr-2"
                    checked={field?.final?.auto_increment}
                    onChange={(e) => {
                      setFieldValue("structure", values?.structure?.map((f, j) => {
                        if (j == idx) return {
                          ...f,
                          final: {
                            ...f.final,
                            auto_increment: e.target.checked,
                            read_only: e.target.checked ? true : f.final.read_only
                          }
                        };
                        return f;
                      }));
                    }}
                  />
                  <h6 className="m-0 p-0" style={{ color: "#777" }}>{l("Valor incremental automático%CA150")}</h6>
                
                </div>
              </div>

            </div>

          </div>
        </td>
      </tr>
    }
  </>;

}

export default ColumnField;